package com.essntl.core.settings.data.supabase.feature

import com.essntl.core.settings.domain.model.feature.AllowedFeaturesModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AllowedFeaturesDto(
    @SerialName("feature_id")
    val feature: String,
    @SerialName("created_at")
    val createdAt: String,
) {
    fun toModel() =
        AllowedFeaturesModel(
            feature = feature,
            createdAt = createdAt,
        )
}
